forms-dialogs-approved-nextstep
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="forms_dialogs_approved_nextstep.inputs.method")
    inputs-hidden(tag-scope="forms_dialogs_approved_nextstep.inputs.authenticity_token")
    input(type="hidden" name="order[under]" value="2")
    input.btn.btn-primary.waves-effect(type="submit" value="{opts.ok}")
  script(type="typescript").
    this.mixin('forms.dialogs.approved-nextstep');
